// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"qp-z","breadcrumbForward":"rp-z","breadcrumbBack":"sp-z","selected":"tp-z"};